import type { OidcConfig } from '@accesso/cc-std-lib';
import type { Provider } from '@angular/core';
import { inject } from '@angular/core';

import { OidcConfiguration, provideOidcService, WINDOW } from '@accesso/cc-std-lib';

import { MerchantStore } from '../../feature/merchant/merchant.store';
import { EnvironmentService } from '../environment/environment.service';

export const provideOidcConfig = (): Provider[] => {
	return [
		{
			provide: OidcConfiguration,
			useFactory: () => {
				const merchant = inject(MerchantStore);
				const store = merchant.store();
				const clientId = store?.authClientId();
				const { location } = inject(WINDOW);

				if (!store || !clientId || !merchant.merchant()?.usesProfiles()) {
					return null;
				}

				return {
					authority: `https://${store.authDomain()}/authorization-service`,
					clientId,
					redirectUri: `${location.origin}/auth_callback`,
					postLogoutRedirectUri: `${location.origin}/auth_callback`,
					responseType: 'code',
					scope: 'openid profile email payments',
					automaticSilentRenew: true,
					redirectTarget: 'self',
				} satisfies OidcConfig;
			},
			deps: [MerchantStore, EnvironmentService],
		},
		provideOidcService(),
	];
};
